import React from 'react';
import noop from '../../utils/noop';
export const PopperDropdownContext = /*#__PURE__*/ React.createContext({
    setToggleRef: noop,
    toggleElement: null
});
PopperDropdownContext.displayName = 'PopperDropdownContext';
